import appendArea from './area';
import appendRoot from '../common/root';
import appendStrokeLine from './strokeLine';
import appendBottomLine from './bottomLine';
import appendLeftLine from './leftLine';
import appendRightLine from './rightLine';
import getScales from '../common/scales';
import vars from '../../../../../../../../../../scss/base/var.module.scss';

export default function appendAreaChart(node, width, height, runs, run, maxY) {
  const { g, areaWidth, areaHeight } = appendRoot(node, width, height);

  const { xScale, yScale } = getScales(areaWidth, areaHeight, runs, maxY);

  appendArea(g, run, vars.colorPrimaryHighlight, xScale, yScale, areaHeight);

  appendStrokeLine(g, xScale, yScale, run, vars.colorPrimaryHighlightDarker30);

  appendBottomLine(g, run, vars.colorPrimaryHighlightDarker30, xScale, yScale);

  appendLeftLine(g, run, vars.colorPrimaryHighlightDarker30, xScale, yScale);

  appendRightLine(g, run, vars.colorPrimaryHighlightDarker30, xScale, yScale);
}
